<template>
  <div class="ac-empty" data-test="ac-empty">
    <span class="ac-empty-mark"><AcIcon :name="icon" :size="22" /></span>
    <div class="ac-empty-title">{{ title }}</div>
    <div class="ac-empty-body">{{ body }}</div>
  </div>
</template>

<script>
import AcIcon from './AcIcon.vue';

// Per-chip empty state (copy lives in actionCenterAlerts.EMPTY_STATES).
export default {
  name: 'ActionCenterEmpty',
  components: { AcIcon },
  props: {
    icon: { type: String, default: 'inbox' },
    title: { type: String, required: true },
    body: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.ac-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 72px 28px;
  text-align: center;
}

.ac-empty-mark {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--ac-iris-50);
  color: var(--ac-iris-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ac-empty-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--ac-text);
}

.ac-empty-body {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ac-text-muted);
  max-width: 250px;
}
</style>
